import { useCallback, useMemo } from 'react'
import { useI18n } from 'builder/hooks/useI18n'
import { FrequencyType } from 'builder/modules/jobSearch/types'

const TRANSLATION = 'builder.job_search.alert_modal.frequencies'

export const useTranslatedFrequenciesString = () => {
  const { i18n } = useI18n()

  const getTranslatedTextFrequency = useCallback(
    (frequency: FrequencyType) => {
      switch (frequency) {
        case FrequencyType.daily:
          return i18n.t(`${TRANSLATION}.day`)
        case FrequencyType.weekly:
          return i18n.t(`${TRANSLATION}.week`)
        case FrequencyType.monthly:
          return i18n.t(`${TRANSLATION}.month`)
        case FrequencyType.two_weeks:
          return i18n.t(`${TRANSLATION}.two_weeks`)
      }
    },
    [i18n],
  )

  const frequenciesValues = useMemo(() => {
    return [FrequencyType.daily, FrequencyType.weekly, FrequencyType.monthly]
  }, [])

  const frequencies = useMemo(() => {
    return frequenciesValues.map((id: FrequencyType) => ({
      id,
      name: getTranslatedTextFrequency(id),
    }))
  }, [frequenciesValues, getTranslatedTextFrequency])

  return { frequencies, getTranslatedTextFrequency }
}
